import { parseQueryString } from '@zg-rentals/string-utils';

import QueryConstants from '../constants/QueryConstants';
import StringConstants from '../constants/StringConstants';

const contextUtils = {
  /** Gets the marketing path value from the search query params. */
  getMarketingPathVal(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH];
  },

  /** Returns true if the marketing path query param is applications. */
  isFromMarketingApplicationsRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.APPLICATIONS;
  },

  /** Returns true if the marketing path query param is payments. */
  isFromMarketingPaymentsRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.PAYMENTS;
  },

  /** Returns true if the marketing path query param is leases. */
  isFromMarketingLeasesRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.LEASES;
  },

  /** Returns true if the redirect query param is payments. */
  isRedirectToPayments(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.REDIRECT_TO] === StringConstants.REDIRECT_TO.PAYMENTS;
  },
};

export default contextUtils;
